import React from 'react';
import {Table} from '@/web-components';
import Util from '../../../../shared/util/util';
import {GLOBAL_FILTER_FIELD, GLOBAL_FILTER_OPERATOR} from '../../../../../constants';
import {getQueryRenderer} from '../TimeRegistrationReportPageUtil';
import {getCurrencyCell, getGroupedRowColumns} from '../TimeRegistrationReportTableUtil';
import {idFromGlobalId} from '../../../../shared/util/GlobalIdUtil';

export const getTaskRow = (
	data,
	intl,
	groupIndex,
	searchQuery,
	groupings,
	enabledColumns,
	hasNextPage,
	fetchMore,
	nextLevelProps,
	currency,
	reportId,
	sharedId,
	customFieldDefinitions,
	customFieldKeys
) => {
	const getColumns = task => {
		const hasAccessToTask = task.hasAccessToTask;
		const noAccessTask = idFromGlobalId(task.taskId) === -1;
		const name = task.noTask
			? intl.formatMessage({id: 'time_reg_report.no_task'})
			: noAccessTask
			? intl.formatMessage({id: 'time_reg_report.no_tasks_access'})
			: task.name;
		return getGroupedRowColumns(
			{
				label: <span>{name}</span>,
				phase: task.phase?.name,
				actualHours: Util.convertMinutesToFullHour(task.timeRegTotals?.totalTimeRegistered, intl, true),
				billableHours: Util.convertMinutesToFullHour(task.timeRegTotals?.totalBillableRegistered, intl, true),
				nonBillableHours: Util.convertMinutesToFullHour(task.timeRegTotals?.totalNonBillableRegistered, intl, true),
				actualBillableValueOfService: getCurrencyCell(task.timeRegTotals?.totalPrice, currency, intl, hasAccessToTask),
				actualCost: getCurrencyCell(task.timeRegTotals?.totalCost, currency, intl, hasAccessToTask),
			},
			customFieldDefinitions
		);
	};

	return (
		<Table.Rows
			data={data}
			canExpand={true}
			autoload={hasNextPage && groupIndex === 1}
			loadMore={hasNextPage ? fetchMore : false}
			{...nextLevelProps}
		>
			{({rowData, tableColumnsProps, nextLevelProps, expanded}) => {
				const filterField =
					rowData.noTask === true ? GLOBAL_FILTER_FIELD.NON_TASK_TIME_REG : GLOBAL_FILTER_FIELD.TASK_TIME_REG;
				return (
					<>
						<Table.Row canExpandRow={rowData.canExpand} {...tableColumnsProps}>
							{getColumns(rowData)}
						</Table.Row>
						{expanded &&
							getQueryRenderer(
								null,
								groupings,
								searchQuery,
								groupIndex,
								enabledColumns,
								{field: filterField, operator: GLOBAL_FILTER_OPERATOR.IS, value: [rowData.taskId]},
								nextLevelProps,
								currency,
								reportId,
								sharedId,
								customFieldDefinitions,
								customFieldKeys
							)}
					</>
				);
			}}
		</Table.Rows>
	);
};
